module.exports = __webpack_public_path__ + "img/roi_high-profile_taxes.5d7dc29a.jpg";